import { Session } from '@ais-ui/auth';

export const getCountries = async (
  session: Session
): Promise<string[] | null> => {
  const response = await session.request('getCountries', {});

  return response;
};

export const getShipTypes = async (
  session: Session
): Promise<string[] | null> => {
  const response = await session.request('getShipTypes', {});

  return response;
};

export const getNavigationalStatuses = async (
  session: Session
): Promise<string[] | null> => {
  const response = await session.request('getNavigationalStatuses', {});

  return response;
};

export const getRegions = async (
  session: Session
): Promise<string[] | null> => {
  const response = await session.request('getRegions', {});

  return response;
};

export const getFilterList = async (
  session: Session
): Promise<string[] | null> => {
  const response = await session.request('getFilterList', {});

  return response;
};

export const getGeoshapeslist = async (
  session: Session
): Promise<string[] | null> => {
  const response = await session.request('geoshapeslist', {});

  return response;
};
